import { render, staticRenderFns } from "./HeaderNavigation.vue?vue&type=template&id=3700bbf0&"
import script from "./HeaderNavigation.vue?vue&type=script&lang=js&"
export * from "./HeaderNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports